import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@mui/material";
import { getHeaderTitle } from "./userProfileHelpers";

export const UserProfileHeader = ({
  isSeller,
  showSaveFlag,
  showBusinessFlag,
  profileSection,
  businessSection,
  handleEdit,
  handleCancelProfile,
  handleProfileSave,
  isProfileSaveDisabled,
  isBusinessSaveDisabled,
  goToSection,
  isIdpLogin,
  isEditDisabled = false
}) => {
  const renderEditButton = () => (
    <div>
      <Button className="editBtnCls" variant="outlined" onClick={handleEdit} disabled={isEditDisabled}>
        Edit
      </Button>
    </div>
  );

  const renderSaveButtons = (isDisabled) => (
    <div>
      <Button
        style={{
          background: "#1214151A",
          textTransform: "none",
          height: "32px",
          width: "116px",
          color: "#2A2C2D",
          fontWeight: "500",
          fontSize: "14px",
          lineHeight: "16.41px",
          boxShadow: "none",
        }}
        variant="contained"
        onClick={handleCancelProfile}
      >
        Cancel
      </Button>
      &nbsp;&nbsp;
      <Button
        style={{
          background: "221.2 83.2% 53.3%",
          textTransform: "none",
          height: "32px",
          width: "116px",
          fontWeight: "500",
          fontSize: "14px",
          lineHeight: "16.41px",
          boxShadow: "none",
        }}
        variant="contained"
        onClick={handleProfileSave}
        disabled={isDisabled}
      >
        Save
      </Button>
    </div>
  );

  const renderHeaderButtons = () => {
    if (!showSaveFlag && profileSection && !isIdpLogin) {
      return renderEditButton();
    }
    if (!showBusinessFlag && businessSection) {
      return renderEditButton();
    }
    if (showSaveFlag) {
      return renderSaveButtons(isProfileSaveDisabled);
    }
    if (showBusinessFlag) {
      return renderSaveButtons(isBusinessSaveDisabled);
    }
    return null;
  };

  return (
    <>
      <div className="contentHeaderCls">
        <div className={isSeller ? "otherHeaderProfileCls" : "headerProfileCls"}>
          {getHeaderTitle(showSaveFlag, showBusinessFlag, isSeller, profileSection)}
        </div>
        {renderHeaderButtons()}
      </div>
      {(showSaveFlag || showBusinessFlag) && isSeller && (
        <div className="top-tabs-container">
          <button
            type="button"
            className={`top-tab ${profileSection ? 'active' : ''}`}
            onClick={() => goToSection(1)}
          >
            <span className="tab-number">1</span>
            <Typography className="tab-text">Profile Info</Typography>
          </button>
          <div className="tab-divider"></div>
          <button
            type="button"
            className={`top-tab ${businessSection ? 'active' : ''}`}
            onClick={() => goToSection(2)}
          >
            <span className="tab-number">2</span>
            <Typography className="tab-text">Business Info</Typography>
          </button>
        </div>
      )}
    </>
  );
};

UserProfileHeader.propTypes = {
  isSeller: PropTypes.bool.isRequired,
  showSaveFlag: PropTypes.bool.isRequired,
  showBusinessFlag: PropTypes.bool.isRequired,
  profileSection: PropTypes.bool.isRequired,
  businessSection: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleCancelProfile: PropTypes.func.isRequired,
  handleProfileSave: PropTypes.func.isRequired,
  isProfileSaveDisabled: PropTypes.bool.isRequired,
  isBusinessSaveDisabled: PropTypes.bool.isRequired,
  goToSection: PropTypes.func.isRequired,
  isIdpLogin: PropTypes.bool.isRequired,
  isEditDisabled: PropTypes.bool,
};
